import React, { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import images from '../../../assets/images';
import { useRequest } from '../../../hooks/useRequest';
import { FiArrowLeft } from 'react-icons/fi';
import {useGeneralDispatch, useGeneralState} from '../../../context/general/generalContext';
import {USER_INFO} from '../../../context/general/constants';
const Navbar = () => {
  const navigate = useNavigate();
  const { request } = useRequest();
  const dispatch = useGeneralDispatch()
  const { userInfo } = useGeneralState()
  const [notification, setNotification] = useState([]);
  const [mouseOver, setMouseOver] = useState(false);
  const [messageUploading, setMessageUploading] = useState(0);
  const containerRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    request('post/getNotifications', {
      method: 'POST',
      body: {
        take: 10,
        skip: messageUploading * 10
      }
    }).then((res) => {
      setNotification([...notification.concat(res?.data?.result)]);
    });
  }, [messageUploading]);

  useEffect(() => {
    if (
      containerRef.current?.scrollIntoView({ behavior: 'smooth' }) &&
      notification[0]?.items?.hasNextPage
    ) {
      setMessageUploading(messageUploading + 1);
    }
  }, [containerRef, notification]);

  useEffect(() => {
    if (mouseOver) {
      request('post/setReadNotifications', {
        method: 'POST'
      }).then((res) => {
        console.log('res', res);
      });
    }
  }, [mouseOver]);
  useEffect(() => {
    request('post/getUserInfo',{
      method:'GET'
    }).then(res => {
      console.log(res)
      dispatch({
        type:USER_INFO,
        payload:res.data.result
      })
    })
  },[])

  return (
    <>
      {/* Hello world */}
      <nav className="nav container">
        <div className="nav--list">
          <div className='nav--list--item'>
            {location.pathname == '/my-profile' && (
              <FiArrowLeft size={40} onClick={() => navigate('/')} color="#3ca646" />
            )}
            {
              userInfo.photoUrl && <img
              className="nav--list--item--profile"
              onClick={() => navigate('/my-profile')}
              src={userInfo.photoUrl}
              alt="User Photo"
            />
            }
          </div>

          <div className="nav--list--item">
            <div className="dropdown">
              <button
                //onClick={() => navigate('/notifications')}
                onMouseOver={() => setMouseOver(true)}
                className="dropbtn">
                <span className="nav--list--item--sub bell">
                  <img className="nav--list--item--sub--img" src={images.iconBell} alt="Bell" />
                  {notification[0]?.count.length > 0 && (
                    <span className="nav--list--item--sub--dot">{notification[0]?.count}</span>
                  )}
                </span>
              </button>
              <div ref={containerRef} className="dropdown-content">
                {notification[0]?.items?.items &&
                  notification[0].items.items.map((nf, i) => (
                    <div  onClick={() => navigate(`/detail/${nf.postId}`)} key={i} className="dropdown-content-card">
                      <div className="dropdown-content-card-top">
                        <img src={nf.userProfilePhotoUrl} alt="" />
                        <p>{nf.notificationText}</p>
                      </div>
                      <div className="dropdown-content-card-bottom">{nf.timeInfo}</div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
